import { render } from "./Home.vue?vue&type=template&id=3c4ae94a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3c4ae94a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c4ae94a"

export default script